"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSaveScheduledMail = void 0;
var sdk_ui_1 = require("@gooddata/sdk-ui");
var utils_1 = require("../utils");
/**
 * Hook allowing to schedule email
 * @param config - configuration of the hook
 * @internal
 */
function useSaveScheduledMail(_a) {
    var scheduledMail = _a.scheduledMail, filterContext = _a.filterContext, backend = _a.backend, workspace = _a.workspace, onCancel = _a.onCancel, onError = _a.onError, onLoading = _a.onLoading, onPending = _a.onPending, onSuccess = _a.onSuccess;
    var effectiveBackend = sdk_ui_1.useBackend(backend);
    var effectiveWorkspace = sdk_ui_1.useWorkspace(workspace);
    utils_1.backendInvariant(effectiveBackend, "useSaveScheduledMail");
    utils_1.workspaceInvariant(effectiveWorkspace, "useSaveScheduledMail");
    var promise = scheduledMail
        ? function () {
            return effectiveBackend
                .workspace(effectiveWorkspace)
                .dashboards()
                .createScheduledMail(scheduledMail, filterContext);
        }
        : null;
    return sdk_ui_1.useCancelablePromise({ promise: promise, onCancel: onCancel, onError: onError, onLoading: onLoading, onPending: onPending, onSuccess: onSuccess }, [
        effectiveBackend,
        effectiveWorkspace,
        scheduledMail,
        filterContext,
    ]);
}
exports.useSaveScheduledMail = useSaveScheduledMail;
//# sourceMappingURL=useSaveScheduledMail.js.map